import { toast as sonnerToast } from "sonner";

/**
 * Toast utility using Sonner
 * Provides a similar API to react-toastify for easier migration
 */
export const toast = {
  success: (message: string, options?: { duration?: number }) => {
    sonnerToast.success(message, {
      duration: options?.duration || 5000,
    });
  },
  error: (message: string, options?: { duration?: number }) => {
    sonnerToast.error(message, {
      duration: options?.duration || 5000,
    });
  },
  info: (message: string, options?: { duration?: number }) => {
    sonnerToast.info(message, {
      duration: options?.duration || 5000,
    });
  },
  warning: (message: string, options?: { duration?: number }) => {
    sonnerToast.warning(message, {
      duration: options?.duration || 5000,
    });
  },
  // Direct access to Sonner for advanced usage
  sonner: sonnerToast,
};
